enum ValueFilterActionTypes {
  append = 'append',
  set = 'set',
}

export default ValueFilterActionTypes;
